export const aboutInfo = {
  brand: {
    title: '品牌介绍',
    subtitle: '让每一帧都值得观看',
    description: [
      '豆花视频成立于2020年，是一家专注于正版高清视频内容的在线平台。我们的名字"豆花"寓意着温暖、亲切和家常，正如一碗热腾腾的豆花，我们希望为用户带来温暖舒适的观影体验。',
      '平台汇聚了海量的影视、综艺、动漫、纪录片、短视频等优质内容，覆盖电视剧、电影、综艺、动漫、纪录片、少儿、体育、音乐等多个品类。所有内容均为正版授权，支持1080P至4K超高清画质。',
      '经过多年的发展，豆花视频已成长为国内领先的视频平台之一，累计注册用户超过5000万，日活跃用户超过1500万。我们始终坚持"内容为王，用户至上"的理念，不断优化产品体验，丰富内容生态。',
      '豆花视频拥有强大的技术团队，自研的AI智能推荐系统能够根据用户的观看偏好精准推荐内容。同时，平台持续投入技术创新，推出了AI智能字幕、画中画播放、多端同步等一系列创新功能。',
    ],
  },
  milestones: [
    { year: '2020年', event: '豆花视频正式成立，推出1.0版本' },
    { year: '2021年', event: '注册用户突破1000万，完成A轮融资' },
    { year: '2022年', event: '推出AI智能推荐系统，用户日均观看时长翻倍' },
    { year: '2023年', event: '注册用户突破3000万，推出TV版和PC版' },
    { year: '2024年', event: '荣获"年度最佳视频平台"奖，用户突破5000万' },
  ],
  reputation: {
    title: '用户口碑',
    subtitle: '超过5000万用户的选择与信赖',
    reviews: [
      {
        name: '张先生',
        avatar: 'A',
        rating: 5,
        content: '豆花视频的画质真的太棒了！4K超清看剧体验完全不输电影院。而且更新速度很快，热播剧都能第一时间看到，良心平台！',
        date: '2024-12-10',
      },
      {
        name: '李女士',
        avatar: 'L',
        rating: 5,
        content: '用了豆花视频快两年了，内容越来越丰富。特别是纪录片频道，像《风味人间》《航拍中国》这种高质量的片子特别多。推荐给身边很多朋友了。',
        date: '2024-12-08',
      },
      {
        name: '王同学',
        avatar: 'W',
        rating: 4,
        content: '大学生党表示会员价格很友好，而且经常有优惠活动。最喜欢多端同步功能，手机上看一半回宿舍电脑接着看，进度自动同步太方便了。',
        date: '2024-12-05',
      },
      {
        name: '赵女士',
        avatar: 'Z',
        rating: 5,
        content: '家里的孩子特别喜欢在豆花视频看动画片，少儿频道的资源很丰富。而且有家长控制功能，可以设置观看时长和内容限制，很放心。',
        date: '2024-12-03',
      },
      {
        name: '陈先生',
        avatar: 'C',
        rating: 5,
        content: '作为追剧党，豆花视频的智能推荐真的很准！推荐的全是我喜欢看的类型。而且新剧上线都会有提醒，再也不会错过想看的剧了。',
        date: '2024-12-01',
      },
      {
        name: '刘女士',
        avatar: 'L2',
        rating: 4,
        content: '画质清晰流畅，基本没有卡顿。客服响应也很快，有一次会员问题联系客服，几分钟就解决了。整体体验非常好，会继续支持。',
        date: '2024-11-28',
      },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '我们期待听到您的声音',
    email: 'contact@douhuavideo.com',
    phone: '400-888-6688',
    address: '北京市朝阳区望京科技园豆花大厦A座',
    workingHours: '周一至周日 9:00 - 21:00',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3059.789855966739!2d116.480889!3d39.995803!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35f0547d7e0b0e0b%3A0x4e4e4e4e4e4e4e4e!2z5pyX6LCo5biC5pyd6Ziz5Yy65pyb5LuZ56eR5oqA5Zut!5e0!3m2!1szh-CN!2scn!4v1234567890',
  },
};